import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// [vip等级恢复详情页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=135994009
export const level_restore_homepage = createAsyncThunk(
  '/live/vip/level_restore_homepage',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<InitialStateType['level_restore_homepage']>
    >('/live/vip/level_restore_homepage', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

// [领取vip等级恢复奖励] http://wiki.xunlei.cn/pages/viewpage.action?pageId=135994006
export const rec_level_restore_reward = createAsyncThunk(
  '/live/vip/rec_level_restore_reward',
  async (arg: {stage_no: number}, store: any) => {
    const resp = await http.post(
      '/live/vip/rec_level_restore_reward',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {xcErrorToast: true}
    )
    return resp.data.data
  }
)

// [vip回归任务玩法详情页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=135994185
export const return_mission_homepage = createAsyncThunk(
  '/live/vip/return_mission_homepage',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<InitialStateType['return_mission_homepage']>
    >('/live/vip/return_mission_homepage', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
export interface lottery_award_type {
  id: number // 下标+1
  image: string // 奖品图片
}
// [回归任务玩法抽奖接口] http://wiki.xunlei.cn/pages/viewpage.action?pageId=135994200
export const return_mission_lottery = createAsyncThunk(
  '/live/vip/return_mission_lottery',
  async (arg: {id: number}, store: any) => {
    // id 从1开始
    const resp = await http.post<
      HiyaRes<{
        item: lottery_award_type
      }>
    >(
      '/live/vip/return_mission_lottery',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const return_ml = createAsyncThunk(
  '/live/vip/return_ml',
  async (arg: {id: number}, store: any) => {
    // id 从1开始
    const resp = await http.post<
      HiyaRes<{
        item: lottery_award_type
      }>
    >(
      '/live/vip/return_ml',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {xcErrorToast: true}
    )
    return resp.data.data
  }
)

// 召回
// [回归任务玩法抽奖接口] http://wiki.xunlei.cn/pages/viewpage.action?pageId=135993303
export const acc_homepage = createAsyncThunk(
  '/live/vip/acc_homepage',
  async (arg, store: any) => {
    const resp = await http.post('/live/vip/acc_homepage', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
export const acc_recharge_record = createAsyncThunk(
  '/live/vip/acc_recharge_record',
  async (arg, store: any) => {
    const resp = await http.post(
      '/live/vip/acc_recharge_record',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const ar_record = createAsyncThunk(
  '/live/vip/ar_record',
  async (arg, store: any) => {
    const resp = await http.post(
      '/live/vip/ar_record',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const acc_get_reward = createAsyncThunk(
  '/live/vip/acc_get_reward',
  async (arg, store: any) => {
    const resp = await http.post(
      '/live/vip/acc_get_reward',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export enum missionStatusEnum {
  抽奖前 = 0,
  抽奖中,
  抽奖后,
}

export interface InitialStateType {
  level_restore_homepage?: {
    err_msg: string // 错误信息
    countdown: number //		剩余秒数，<=0代表活动已结束
    privilege_cnt: number //	特权数量
    avatar: string //	头像
    avatar_frame: string //	头像框
    cur_level: number //		当前等级
    highest_level: number //		历史最高等级
    max_score: number //		最大分值
    original_score: number //		原价
    discount: number //		0-100 降价百分比*100
    cur_score: number //		当前分值
    percent: number //		0-100 进度百分比*100
    list: {
      stage_no: number //	阶段
      status: number //	0未领取，1已达到未领取，2已领取
      icon: string //	开奖弹窗的icon
      desc: string // 开奖弹窗的描述文案
      stage_need: number //	达到奖励要的积分
    }[] //	奖励列表
    reward_gap: number //	距离下一个奖励还差多少
    show_guide: boolean // 是否展示引导
  }
  return_mission_homepage?: {
    count_down: number //	倒计时
    status: missionStatusEnum //	状态（抽奖前、抽奖中、抽奖后）
    lottery_barrage: {
      name: string //	昵称
      avatar: string //	头像
      coins: number //	获得金币卡面值
    }[] // 抽奖弹幕
    lottery_award: {
      // 抽奖结果
      id: number
      amount: number // 获得金币卡面值
      num: number //	数量
      type: string //	金币卡类型（Greedy Pro or Greedy Hiya）
      image: string
    }
  }
  acc_homepage?: {
    count_down: number
    acceleration_rates: number[]
    recharge_stage: number[]
    reward: {
      desc: string
      icon: string
      coin_icon: string
      coins: number
      num: number
      expire: number
      // 0未达成领取条件 1已完成未领取 2已领取
      status: 0 | 1 | 2
    }
    exp: number
    exp_diff: number
    target_level: number
    show_guide: boolean // 是否展示引导
  }
}

const initialState: InitialStateType = {}

export const VipRecallSlice = createSlice({
  name: 'VipRecallSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(level_restore_homepage.fulfilled, (state, action) => {
      Object.assign(state, {level_restore_homepage: {...action.payload}})
    })
    builder.addCase(return_mission_homepage.fulfilled, (state, action) => {
      Object.assign(state, {return_mission_homepage: {...action.payload}})
    })
    builder.addCase(acc_homepage.fulfilled, (state, action) => {
      Object.assign(state, {acc_homepage: {...action.payload}})
    })
  },
})
export default VipRecallSlice.reducer
export const VipRecallActions = VipRecallSlice.actions

export const useVipRecallState = () => {
  const data = useSelector((state) => {
    return state.Animal_Bat
  })
  return data
}
